import type { RfidCardType } from '@/api/schema';
import { CardsNumberCell } from '@/components/CardsNumberCell';
import type { Column } from '@/components/Table/Table';
import { ActiveCell } from '@/features/chargingCards/cards/components/ActiveCell';

export const columns = (t: (arg: string) => string): Column<RfidCardType>[] => [
    {
        key: 'number',
        label: t('chargingCards.cardNumber'),
        valueGetter: originalRow => originalRow.number,
        renderCell: ({ row }) => <CardsNumberCell id={row.number} />,
        width: 'width-10pct',
        sortable: true,
    },
    {
        key: 'active',
        label: t('chargingCards.rfidCardStatus'),
        valueGetter: originalRow => originalRow.isActive,
        renderCell: ({ row }) => <ActiveCell card={row} checked={row.isActive} />,
        width: 'width-10pct',
        sortable: true,
    },
    {
        key: 'alias',
        label: t('chargingCards.cardAlias'),
        valueGetter: originalRow => originalRow.alias,
        renderCell: ({ row }) => (
            <span className={row.alias ? 'text-color-black' : 'text-color-gray'}>
                {row.alias ?? t('general.noAliasAdded')}
            </span>
        ),
        sortable: true,
    },
];
